import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import ReactHtml from "raw-html-react";
class Banner2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      sub: [],
      single: [],
    };
  }
  componentDidMount() {
    axios
      .get(
        encodeURI(
          process.env.REACT_APP_API_URL +
            "api/resource/Homepage Section/Big Banner"
        ),
        {
          headers: {
            Authorization: process.env.REACT_APP_TOKEN,
            "content-type": "application/json",
          },
        }
      )
      .then((response) => {
        this.setState({ menu: response.data["data"] });
        //console.log(response.data['data'])
      });
  }
  render() {
    return (
      <div>
        <div class="banner-section section pb-40 pb-sm-30 pb-xs-0">
          <div class="container">
            <ReactHtml html={this.state.menu["section_html"]} />
          </div>
        </div>
      </div>
    );
  }
}
export default Banner2;
